import axiosInstance from '../../utils/axiosInstance';
import endpoints from '../../utils/endpoints';
import serializeStrapiParams from '../../utils/serializeStrapiParams';

const find = async (query) => {
  const { data } = await axiosInstance.get(endpoints.prizes(), {
    params: query,
    paramsSerializer: (params) => {
      const pairs = serializeStrapiParams(params);
      return pairs.join('&');
    },
  });
  return data;
};

const findOne = async (id) => {
  const sid = String(id);
  if (!id || sid.trim() === '' || sid.startsWith(':')) {
    throw new Error('Prize ID is required');
  }
  const { data } = await axiosInstance.get(endpoints.prizes(sid), {
    params: {
      populate: {
        Object: {
          fields: ['Title', 'documentId', 'Coordinates'],
          populate: {
            subcategories: {
              fields: ['Title', 'IconName'],
            },
          },
        },
        PrizeImages: true,
      },
    },
    paramsSerializer: (params) => serializeStrapiParams(params).join('&'),
  });
  return data?.data ?? data;
};

const create = async (payload) => {
  const body = { data: payload };
  const { data: result } = await axiosInstance.post(endpoints.prizes(), body);
  return result;
};

const update = async (id, payload) => {
  if (!id) {
    throw new Error('Prize ID is required');
  }
  const body = { data: payload };
  const { data: result } = await axiosInstance.put(endpoints.prizes(id), body);
  return result;
};

const remove = async (id) => {
  if (!id) {
    throw new Error('Prize ID is required');
  }
  const response = await axiosInstance.delete(endpoints.prizes(id));
  return response?.data;
};

/**
 * @param {{ lat?: number, lng?: number, locale?: string }} query
 */
const findForProfile = async (query = {}) => {
  const { data } = await axiosInstance.get(endpoints.prizesForProfile, {
    params: query,
  });
  return data?.data ?? data;
};

const client = { find, findOne, create, update, remove, findForProfile };

export default client;
